import React, { useState } from 'react';
import styles from './Privacy.module.css';

const PrivacyPolicy = ({ ownerName, email, address, domain, updateDate = "אוגוסט 2025" }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button className={styles.link} onClick={() => setIsOpen(true)}>
        תקנון ומדיניות פרטיות
      </button>

      {isOpen && (
        <div className={styles.modalOverlay} onClick={() => setIsOpen(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h2>תקנון, תנאי שימוש ומדיניות פרטיות - {ownerName}</h2>
            <p>עודכן לאחרונה: {updateDate}</p>
            <p>בעל האתר: {ownerName}, {address}</p>
            <p>דוא״ל: {email}</p>
            <p>כתובת האתר: {domain}</p>

            <h3>1. מבוא</h3>
            <p>ברוך הבא לאתר {domain} ("האתר"). השימוש באתר, בתכניו ובשירותיו כפוף לתנאים המפורטים במסמך זה ("התקנון"), ומהווה את הסכמתך לכל תנאיו. אם אינך מסכים לאחד או יותר מהתנאים - אנא הימנע משימוש באתר.</p>
            <p>האתר משמש כפלטפורמה להצגת שירותים, תוכן מקצועי, מידע שיווקי וכלים מקוונים בתחומי פעילותו של {ownerName}.</p>
            <p>התקנון נוסח בלשון זכר מטעמי נוחות בלבד אך מיועד לשני המינים.</p>

            <h3>2. שימוש מותר באתר</h3>
            <p>השימוש באתר מיועד למטרות פרטיות בלבד, ואינו מקנה לך זכות להעתיק, לשכפל, לשנות, להפיץ או לפרסם תכנים מהאתר ללא אישור בכתב ומראש מבעל האתר.</p>
            <p>חל איסור לעשות שימוש באתר או בשירותיו לכל מטרה בלתי חוקית, לרבות פגיעה בפרטיות, חדירה למערכות, הפצת דואר זבל או ניסיון להונות.</p>
            <p>אין לקשר לאתר מאתרים בעלי תכנים פוגעניים, פורנוגרפיים, מפלים או המעודדים פעילות בלתי חוקית.</p>

            <h3>3. הרשאה לדיוור ושיווק</h3>
            <p>מסירת פרטים באתר מהווה הסכמה לקבלת תוכן שיווקי, עדכונים והצעות פרסום בהתאם לחוק התקשורת (בזק ושידורים), תשמ״ב-1982, תיקון 40.</p>
            <p>ניתן להסיר עצמך בכל עת מרשימת התפוצה באמצעות הקישור המופיע בדיוור או בפנייה ישירה לבעל האתר.</p>
            <p>חל איסור למסור באתר פרטים של אדם אחר ללא הסכמתו המפורשת.</p>

            <h3>4. איסוף מידע ושימוש בו (מדיניות פרטיות)</h3>
            <p>האתר פועל בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, ותקנות הגנת הפרטיות (אבטחת מידע), לרבות תיקון 13 (2024).</p>

            <h4>4.1 סוגי המידע הנאספים:</h4>
            <ul>
              <li>מידע שאתה מוסר ישירות: שם, פרטי קשר, תוכן פנייה, פרטי שירותים שהתעניינת בהם.</li>
              <li>מידע הנאסף אוטומטית: כתובת IP, סוג דפדפן, מערכת הפעלה, מיקומי גלישה, נתוני שימוש באתר, Cookies.</li>
            </ul>

            <h4>4.2 מטרות השימוש במידע:</h4>
            <ul>
              <li>אספקת השירותים שביקשת.</li>
              <li>התאמת חוויית הגלישה.</li>
              <li>שיווק, פרסום והצעות מותאמות אישית.</li>
              <li>ניתוח סטטיסטי ושיפור השירותים.</li>
              <li>עמידה בהוראות הדין.</li>
            </ul>

      

            <h4>4.3 זכויותיך:</h4>
            <ul>
              <li>עיון במידע שנאסף.</li>
              <li>תיקון או מחיקה.</li>
              <li>התנגדות לשיווק.</li>
            </ul>
            <p>לפניות: {email}</p>

            <h3>5. Cookies וטכנולוגיות מעקב</h3>
            <p>האתר משתמש ב־Cookies וכלים אנליטיים (Google Analytics) לצורך תפעול, שיפור והתאמת חוויית המשתמש.</p>
            <p>ניתן לחסום אותם דרך הדפדפן, אך זה עלול לפגוע בחוויית השימוש.</p>

            <h3>6. אחריות והגבלת אחריות</h3>
            <p>התכנים באתר ניתנים כמות שהם (AS IS). אין התחייבות להתאמה מלאה לצרכים שלך.</p>
            <p>בעל האתר אינו אחראי לנזק ישיר או עקיף עקב הסתמכות על התוכן.</p>
            <p>שירותים מקצועיים אינם תחליף לייעוץ אישי מותאם.</p>

            <h3>7. קניין רוחני</h3>
            <p>כל הזכויות בתכנים, קוד, מדיה, לוגו ועיצובים שמורות ל{ownerName}, אלא אם צוין אחרת.</p>

            <h3>8. אבטחת מידע</h3>
            <p>האתר מיישם אמצעי הגנה מתקדמים לפי חוק. במקרה של פריצה, תינתן הודעה לרשות להגנת הפרטיות ולמשתמשים הרלוונטיים.</p>

            <h3>9. שינויים במדיניות</h3>
            <p>האתר רשאי לעדכן את התקנון ומדיניות הפרטיות. שימוש באתר מהווה הסכמה לתנאים המעודכנים.</p>

       
            <h3>11. יצירת קשר</h3>
            <p>לשאלות, פניות או בקשות:</p>
            <p>{ownerName}</p>
            <p>{email}</p>
            <p>{address}</p>

            <button className={styles.closeButton} onClick={() => setIsOpen(false)}>
              סגירה
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PrivacyPolicy;
